import { css as o } from "@microsoft/fast-element";
import { normalize as a } from "../common/normalize.js";
import { display as d, PropertyStyleSheetBehavior as i } from "@matrix42/fast-foundation";
import { designTokens as e } from "../design-tokens.js";
function r(t, l) {
  return new i("variant", t, l);
}
const s = (t) => o`
  ::slotted(${t.prefix}-thead) {
    /* Style */
    background-color: ${e.color.neutral[50]};
  }

  ::slotted(${t.prefix}-trow:nth-child(even)) {
    /* Style */
    background-color: ${e.color.white};
  }

  ::slotted(${t.prefix}-trow:nth-child(odd)) {
    /* Style */
    background-color: ${e.color.neutral[30]};
  }
`, n = (t) => o`
  ::slotted(${t.prefix}-thead),
  ::slotted(${t.prefix}-trow) {
    /* Style */
    border-bottom: ${e.borderWidth.xs} solid !important;
  }

  ::slotted(${t.prefix}-thead) {
    /* Style */
    border-color: ${e.color.neutral[80]} !important;
  }

  ::slotted(${t.prefix}-trow) {
    /* Style */
    border-color: ${e.color.neutral[60]} !important;
  }
`, $ = (t) => o`
    ${a}
    ${d("table")}
  :host {
      /* Base */
      width: 100%;
      border-collapse: collapse;
    }
  `.withBehaviors(
  r("zebra", s(t)),
  r("line", n(t))
);
export {
  $ as tableStyles
};
